// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldprobEntity from './entities/ldprob.json';
import ldprobMenu from '../pages/ldprob/menu.json';
import ldprobFullForm from '../pages/ldprob/forms/full.json';
import ldprobContextForm from '../pages/ldprob/forms/context.json';
import ldprobMiniForm from '../pages/ldprob/forms/mini.json';
import ldprobLookupForm from '../pages/ldprob/forms/lookup.json';
import ldprobTableView from '../pages/ldprob/views/table.json';
import ldprobStagesView from '../pages/ldprob/views/stages.json';
import ldprobCardsView from '../pages/ldprob/views/cards.json';
import ldprobInlineView from '../pages/ldprob/views/inline.json';
import ldprobBacklogView from '../pages/ldprob/views/backlog.json';
import ldprobSplitView from '../pages/ldprob/views/split.json';
import ldprobCalendarView from '../pages/ldprob/views/calendar.json';
import ldprobDashboardView from '../pages/ldprob/views/dashboard.json';

/** Тип запису «Проблема, яку розв’язує» зі сторінками пакета: меню, форми та подання з pages/ldprob/. */
export const ldprobDefinition: IRecordTypeDefinition = {
  ...ldprobEntity,
  views: assembleViewSet({
      table: ldprobTableView,
      stages: ldprobStagesView,
      cards: ldprobCardsView,
      inline: ldprobInlineView,
      backlog: ldprobBacklogView,
      split: ldprobSplitView,
      calendar: ldprobCalendarView,
      dashboard: ldprobDashboardView,
  }),
  form: ldprobFullForm,
  forms: { full: ldprobFullForm, context: ldprobContextForm, mini: ldprobMiniForm, lookup: ldprobLookupForm },
  menu: ldprobMenu,
} as IRecordTypeDefinition;
